import type { Locale } from '@/lib/i18n';
import type { ToolTranslations } from './types';
import { toolsHi } from './hi';

const TOOL_TRANSLATIONS: Partial<Record<Locale, ToolTranslations>> = { hi: toolsHi };

export const getToolTranslations = (locale: Locale): ToolTranslations | null => TOOL_TRANSLATIONS[locale] ?? null;
export type { ToolSlug, ToolText, ToolTranslations } from './types';
